import { createFileRoute } from '@tanstack/react-router';
import NotionPage from '@/pages/static/NotionPage';

export const Route = createFileRoute('/notion')({
  component: NotionPage,
});
